export default __webpack_public_path__ + "static/media/archeological-dig.1f3166e1.svg";